

import { Select } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { getCookie } from "typescript-cookie";
import { useGetUnitMeasurementCategoryQuery } from "../../redux/api/handBooksApi/categoryMeasurementApi";

interface IProps {
    value?: number | null;
    onChange?: () => void;
    parentNull?: boolean;
}

const SelectUnitMeasurementCategory = (props: IProps) => {
    const { t } = useTranslation();
    const [options, setOptions] = useState<ISelectOption[]>([]);

    const { data, isLoading } = useGetUnitMeasurementCategoryQuery();
    useEffect(() => {
        const status = data?.res;
        if (status === undefined || status === null)
            setOptions([]);
        else {
            const options = status.map((a) => {
                return { label: getCookie('i18next') === 'ky' ? a.nameKy : a.nameRu, value: a.id };
            });
            setOptions(options);
        }
    }, [data]);

    return (
        <Select
            placeholder={ t("msg.selectPlaceholder") }
            loading={ isLoading }
            value={ props.value }
            onChange={ props.onChange }
            options={ options }
            filterOption={ defaultFilterOption }
            showSearch
            allowClear
        />
    );
};

export default SelectUnitMeasurementCategory;